/* URSO - Compre Junto: guarda do combo completo (Buda Digital)

   O desconto do Compre Junto viaja em propriedades de linha gravadas pela
   secao "Urso: Compre junto" no momento em que o combo e adicionado:

     _cj_desc -> percentual daquele item complementar
     _cj_base -> handle do produto principal, o dono do combo

   Se o cliente tira o produto principal do carrinho, o combo deixou de
   existir e os complementares nao podem seguir com preco de combo. Sempre
   que o carrinho muda, este script:

     1. guarda o percentual em _cj_off e zera _cj_desc nas linhas cujo
        produto principal saiu do carrinho - sem _cj_desc a Shopify Function
        nao aplica desconto nenhum;
     2. devolve o percentual de _cj_off para _cj_desc se o produto principal
        voltar para o carrinho, para quem remove sem querer nao ficar preso
        ao preco cheio.

   Esta guarda e a camada visivel, do lado do cliente. A checagem que vale
   dinheiro no checkout mora dentro da Function. */
(function () {
  'use strict';

  if (window.ursoCjGuardOn) return;
  window.ursoCjGuardOn = true;

  var ROTAS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  var limpando = false;
  var agendado = null;

  function normaliza(v) {
    if (v === null || v === undefined) return '';
    return String(v).trim().toLowerCase();
  }

  function pct(valor) {
    var bruto = normaliza(valor).replace('%', '').replace(',', '.');
    if (bruto === '') return 0;
    var n = Number(bruto);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function ativo(item) {
    return pct((item.properties || {})._cj_desc) > 0;
  }

  function guardado(item) {
    return pct((item.properties || {})._cj_off) > 0;
  }

  function base(item) {
    return normaliza((item.properties || {})._cj_base);
  }

  /* Uma linha que participa de combo - com desconto ativo ou guardado - nunca
     vale como produto principal de outra, para dois complementares nao
     validarem um ao outro. */
  function principais(itens) {
    var maes = {};
    for (var i = 0; i < itens.length; i++) {
      if (ativo(itens[i]) || guardado(itens[i])) continue;
      var h = normaliza(itens[i].handle);
      if (h) maes[h] = true;
    }
    return maes;
  }

  /* Linhas a corrigir: as que perderam o produto principal (guardar) e as que
     o recuperaram (devolver). */
  function pendentes(cart) {
    var itens = (cart && cart.items) || [];
    var maes = principais(itens);
    var lista = [];

    for (var i = 0; i < itens.length; i++) {
      var it = itens[i];
      var b = base(it);
      var temMae = b !== '' && !!maes[b];

      if (ativo(it) && !temMae) lista.push({ item: it, acao: 'guardar' });
      else if (!ativo(it) && guardado(it) && temMae) lista.push({ item: it, acao: 'devolver' });
    }
    return lista;
  }

  function propsCorrigidas(item, acao) {
    var p = item.properties || {};
    var saida = {};
    for (var k in p) {
      if (Object.prototype.hasOwnProperty.call(p, k)) saida[k] = p[k];
    }
    if (acao === 'guardar') {
      saida._cj_off = p._cj_desc;
      saida._cj_desc = '';
    } else {
      saida._cj_desc = p._cj_off;
      saida._cj_off = '';
    }
    return saida;
  }

  function pegaCarrinho() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function redesenha(res) {
    var drawer = document.querySelector('cart-drawer');
    if (res && res.sections && drawer && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(res);
        return;
      } catch (e) {
        /* cai no plano B */
      }
    }
    var alvo = document.getElementById('shopify-section-cart-drawer');
    var html = res && res.sections && res.sections['cart-drawer'];
    if (!alvo || !html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var novo = doc.getElementById('shopify-section-cart-drawer');
      if (!novo) return;
      var aberto = !!alvo.querySelector('cart-drawer.is-open, cart-drawer.active, cart-drawer[open]');
      alvo.innerHTML = novo.innerHTML;
      if (aberto && typeof window.ursoOpenCart === 'function') window.ursoOpenCart();
    } catch (e) {
      /* silencio: a correcao dos dados ja aconteceu */
    }
  }

  function corrige(pendente, ultimo) {
    var corpo = {
      id: pendente.item.key,
      quantity: pendente.item.quantity,
      properties: propsCorrigidas(pendente.item, pendente.acao),
    };
    if (ultimo) {
      corpo.sections = 'cart-drawer,cart-icon-bubble';
      corpo.sections_url = window.location.pathname;
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo),
    }).then(function (r) {
      return r.json();
    });
  }

  function verifica() {
    if (limpando) return Promise.resolve();
    limpando = true;

    /* uma linha por vez: cada change.js reescreve as chaves das linhas */
    function passo(indice) {
      return pegaCarrinho().then(function (cart) {
        var lista = pendentes(cart);
        if (!lista.length || indice > 20) return null;
        return corrige(lista[0], lista.length === 1).then(function (res) {
          if (lista.length === 1) return res;
          return passo(indice + 1);
        });
      });
    }

    return passo(0)
      .then(function (res) {
        if (res) redesenha(res);
      })
      .catch(function () {
        /* rede fora do ar: a Function ainda protege o valor no checkout */
      })
      .then(function () {
        limpando = false;
      });
  }

  function agenda() {
    if (agendado) window.clearTimeout(agendado);
    agendado = window.setTimeout(function () {
      agendado = null;
      verifica();
    }, 120);
  }

  function ehRotaDeCarrinho(entrada) {
    var url = '';
    if (typeof entrada === 'string') url = entrada;
    else if (entrada && entrada.url) url = entrada.url;
    else if (entrada && typeof entrada.toString === 'function') url = entrada.toString();
    for (var i = 0; i < ROTAS.length; i++) {
      if (url.indexOf(ROTAS[i]) !== -1) return true;
    }
    return false;
  }

  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function') {
    window.fetch = function (entrada, opcoes) {
      var chamada = fetchOriginal.apply(this, arguments);
      if (!limpando && ehRotaDeCarrinho(entrada)) {
        chamada.then(function () { agenda(); }).catch(function () {});
      }
      return chamada;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verifica);
  } else {
    verifica();
  }
})();
